import { Image, Menu, MenuProps } from "antd";
import Sider from "antd/es/layout/Sider";
import { MenuInfo } from "rc-menu/lib/interface";
import { useCallback, useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./SideBarMenu.module.scss";
import { Twirl as Hamburger } from "hamburger-react";
import spacing from "../../ui/spacingConfig";
import { useRole } from "../../../features/roles/useRole";

export const SideBarMenu: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAdmin } = useRole();
  const [isMobileSidebarVisible, setIsMobileSidebarVisible] = useState(false);

  const onMenuClick = useCallback(
    (e: MenuInfo) => {
      navigate(e.key);
      setIsMobileSidebarVisible(false);
    },
    [navigate],
  );

  const toggleSidebar = () => {
    setIsMobileSidebarVisible((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 765) {
        setIsMobileSidebarVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems: MenuProps["items"] = useMemo(() => {
    const items = [
      { key: "/", label: "Tableau de bord" },
      { key: "/events", label: "ÃvÃ©nements" },
    ];
    if (isAdmin) {
      items.push({ key: "/users", label: "Utilisateurs" });
    }
    return items;
  }, [isAdmin]);

  return (
    <>
      <div className={styles.hamburger}>
        <Hamburger
          size={spacing.sm}
          toggled={isMobileSidebarVisible}
          toggle={toggleSidebar}
          color={isMobileSidebarVisible ? "white" : "black"}
        />
      </div>
      <Sider
        width={200}
        theme="light"
        className={`${styles.root} ${isMobileSidebarVisible ? styles.mobileVisible : ""}`}
      >
        <div className={styles.logo}>
          <Image
            src={`${process.env.PUBLIC_URL}/images/logo-sdlp_white.png`}
            alt="SDLP Logo"
          />
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={onMenuClick}
        />
      </Sider>
      {isMobileSidebarVisible && (
        <div className={styles.overlay} onClick={toggleSidebar} />
      )}
    </>
  );
};

export default SideBarMenu;
